import LocalPoliceOutlinedIcon from "@mui/icons-material/LocalPoliceOutlined";
import { EmptyState } from "../../../shared/ui";

export type CoReviewQueueTab = "pending" | "approved" | "returned" | "committed";

const COPY: Record<CoReviewQueueTab, { title: string; description: string }> = {
  pending: {
    title: "No reports waiting for review",
    description:
      "When officers sign and submit reports, they appear here for your review.",
  },
  approved: {
    title: "No approved reports",
    description:
      "Reports you approve stay here until they are submitted to your Records System.",
  },
  returned: {
    title: "No reports sent back for changes",
    description:
      "Reports you return with comments appear here until the officer resubmits them.",
  },
  committed: {
    title: "No reports submitted to Records System yet",
    description: "Reports submitted to your Records System appear here.",
  },
};

/** Tab-aware empty state for the CO review queue (the Home empty state's
 *  filter/CTA affordances don't apply here). */
export function CoReviewQueueEmptyState({ tab }: { tab: CoReviewQueueTab }) {
  return (
    <EmptyState
      variant="panel"
      icon={<LocalPoliceOutlinedIcon />}
      title={COPY[tab].title}
      description={COPY[tab].description}
    />
  );
}
